var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3cpath fill='%23ed2939' d='M0 0h900v600H0z'/%3e%3cpath fill='white' d='M0 200h900v200H0z'/%3e%3c/svg%3e";
  export default img;